import HomePage from '../components/Home/HomeContainer.vue';
import Charts from '../components/Charts/ChartsContainer.vue';
import Tables from '../components/Tables/TablesContainer.vue';

export default [
  { path: '/', component: HomePage },
  { path: '/graphs', component: Charts },
  { path: '/tables', component: Tables }
];
